import React from 'react';
import getViewAllCtaUrl from '../../utils/getViewAllCtaUrl';
import { navigationEvent } from 'services/dataLayerService';
import Button from 'components/Core/Button';
import WebsiteImage from 'components/WebsiteImage';
import HyperLink from 'components/Core/HyperLink';
import { ChildMenuContainer, NavItemsContainer, NavItem, ButtonsContainer } from './styles';

const ChildNav = ({ selectedSubMenu, setMobileMenuOpened }) => {
  const { ctas, subNavigationElement, label } = selectedSubMenu || {};
  const groups = Array.from(new Set(subNavigationElement?.map((x) => x.group?.group))).sort();
  const orderedGroups = groups?.[0] === 'By Features' ? groups.reverse() : groups;
  const type = selectedSubMenu?.subNavigationElement?.every(
    (elem) => elem.businessType === 'Commercial',
  )
    ? 'Commercial'
    : 'Residential';

  let menuCtas = ctas;

  if (label === 'Solutions') {
    menuCtas = [ctas?.[subNavigationElement?.[0]?.businessType === 'Commercial' ? 0 : 1]];
  }

  return (
    <ChildMenuContainer className="mobile-child-nav">
      {orderedGroups?.map((groupLabel, index) => {
        const viewAllUrl = getViewAllCtaUrl(type, groupLabel);
        const label =
          groupLabel === 'Get more with Pro' ? (
            <>
              Get more with <span>Pro</span>
            </>
          ) : (
            groupLabel
          );

        return (
          <NavItemsContainer index={index}>
            {groupLabel && (
              <p className="group-label font-sm">
                <b>{label}</b>
              </p>
            )}
            {subNavigationElement?.map((navEle) => {
              const label = navEle?.label;
              const labelToRender = label?.endsWith('Beta') ? (
                <>
                  {label?.slice(0, -4)} <span class="beta">Beta</span>
                </>
              ) : (
                label
              );
              return (
                navEle.group?.group === groupLabel && (
                  <HyperLink
                    href={navEle.url}
                    onClick={() => {
                      navigationEvent(navEle.label, navEle.url);
                      setMobileMenuOpened(false);
                    }}
                  >
                    <NavItem>
                      <WebsiteImage
                        {...navEle.icon}
                        loading="eager"
                        widthMobile="24px"
                        widthDesktop="24px"
                      />
                      <p className="nav-item-label font-p">
                        <b>{labelToRender}</b>
                      </p>
                    </NavItem>
                  </HyperLink>
                )
              );
            })}
            {selectedSubMenu?.label === 'Solutions' && (
              <ButtonsContainer className={index === 0 ? 'top-btn' : ''}>
                <Button
                  to={viewAllUrl}
                  type="transparent - black border"
                  className="header-menu-cta"
                  onClick={() => {
                    navigationEvent('View All', viewAllUrl);
                    setMobileMenuOpened(false);
                  }}
                >
                  <p className="font-sm">
                    <b>View All</b>
                  </p>
                </Button>
              </ButtonsContainer>
            )}
          </NavItemsContainer>
        );
      })}
      {selectedSubMenu?.label !== 'Solutions' && (
        <ButtonsContainer>
          {menuCtas?.[0] !== undefined &&
            menuCtas?.map((cta) => {
              return (
                <Button
                  dataPosition="Header - Menu Item CTA"
                  type="transparent - black border"
                  to={cta.url}
                  onClick={() => {
                    navigationEvent(cta.buttonLabel, cta.url);
                    setMobileMenuOpened(false);
                  }}
                  className="header-menu-cta"
                >
                  <p className="font-sm">
                    <b>{cta.buttonLabel}</b>
                  </p>
                </Button>
              );
            })}
        </ButtonsContainer>
      )}
    </ChildMenuContainer>
  );
};

export default ChildNav;
